import { Component, HostBinding, OnDestroy, OnInit } from "@angular/core";
import { Subject, combineLatest } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ManagerService } from "../../../core/services/manager.service";
import {
  EMPTY_TRB_INSIGHTS,
  TrbInsightsResponse,
} from "../../../core/services/data-manager.service";
import { ConfigService } from "../../../core/services/config.service";
import { CurrencyInfo } from "../../../shared/models/currency-info";

@Component({
  selector: "app-my-insights",
  templateUrl: "./my-insights.component.html",
  styleUrls: ["./my-insights.component.scss"],
})
export class MyInsightsComponent implements OnInit, OnDestroy {
  insights: TrbInsightsResponse = EMPTY_TRB_INSIGHTS;
  currencyInfo: CurrencyInfo | null = null;
  loading = true;
  private destroy$ = new Subject<void>();

  @HostBinding("class.cantobyte")
  get isCantobyte(): boolean {
    return this.configService.config?.brand === "cantobyte";
  }

  constructor(
    private managerService: ManagerService,
    private configService: ConfigService
  ) { }

  ngOnInit(): void {
    this.managerService.fetchTrbInsights();

    combineLatest([
      this.managerService.trbInsights$,
      this.managerService.user$,
      this.managerService.trbInsightsReady$,
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([insights, user, ready]) => {
      
        this.insights = insights || EMPTY_TRB_INSIGHTS;
        const currencies = this.managerService.currencyInfo || [];
        this.currencyInfo =
          currencies.find((item) => item.Id === this.insights.currency) ||
          user?.selectedCurrency ||
          null;
          this.loading = !ready;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  formatHands(value: number): string {
    if (value == null) {
      return "0";
    }
    if (value < 1000) {
      return String(value);
    }
    const thousands = value / 1000;
    const rounded =
      thousands >= 100 ? Math.round(thousands) : Math.round(thousands * 10) / 10;
    return `${rounded}k`;
  }

  formatTrb(value: number): string {
    const amount = Number(value);
    if (!isFinite(amount)) {
      return "0";
    }
    const formatted = amount.toLocaleString("en-US", {
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    });
    const symbol = this.currencyInfo?.Symbol;
    if (!symbol) {
      return formatted;
    }
    return this.currencyInfo.SymbolAfter
      ? `${formatted} ${symbol}`
      : `${symbol} ${formatted}`;
  }
}
